var map = {
	".": "LuFD",
	"./": "LuFD",
	"./00_get_account_balance": "hIqz",
	"./00_get_account_balance.json": "hIqz",
	"./02_get_asset_transfer2": "ah5Z",
	"./02_get_asset_transfer2.json": "ah5Z",
	"./07_post_capital_innerTransfer_apply": "iYO+",
	"./07_post_capital_innerTransfer_apply.json": "iYO+",
	"./08_post_asset_transfer_new": "Oo3f",
	"./08_post_asset_transfer_new.json": "Oo3f",
	"./09_get_account_transfer_support_coin": "QJQq",
	"./09_get_account_transfer_support_coin.json": "QJQq",
	"./10_get_asset_transfer_record": "fqje",
	"./10_get_asset_transfer_record.json": "fqje",
	"./11_get_fund_account_balance": "dOYV",
	"./11_get_fund_account_balance.json": "dOYV",
	"./14.get_wallet_queryInnerTransferRecords": "Jtu9",
	"./14.get_wallet_queryInnerTransferRecords.json": "Jtu9",
	"./21_get_account_allAccountBalance": "9SLF",
	"./21_get_account_allAccountBalance.json": "9SLF",
	"./index": "LuFD",
	"./index.js": "LuFD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6DOK";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/account ^.*$
// module id = 6DOK
// module chunks = 3